const NextDayPhone = () =>
  import('@/views/main/helper/nextDayPhone/NextDayPhone.vue')
export default {
  path: '/main/helper/nextDayPhone',
  name: 'NextDayPhone',
  component: NextDayPhone
}
